import { createStore } from "satcheljs";
import { GridSelectionViewStateStore } from "sh-application/components/schedule/selection/lib/store/schema/GridSelectionViewStateStoreSchema";
import { ObservableMap } from "mobx";

const initialStore: GridSelectionViewStateStore = {
    selectedCellKeys: new ObservableMap<string, boolean>()
};

const gridSelectionViewStateStore = createStore<GridSelectionViewStateStore>('gridSelectionViewStateStore', initialStore);
export default gridSelectionViewStateStore;